import ar from './locales/ar/language.json';
import de from './locales/de/language.json';
import en from './locales/en/language.json';
import es from './locales/es/language.json';
import fr from './locales/fr/language.json';
import hi from './locales/hi/language.json';
import ja from './locales/ja/language.json';
import ko from './locales/ko/language.json';
import ru from './locales/ru/language.json';
import tl from './locales/tl/language.json';
import vi from './locales/vi/language.json';
import zh from './locales/zh/language.json';
import bn from './locales/bn/language.json';

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const languages = {
  ar: { translation: ar },
  de: { translation: de },
  en: { translation: en },
  es: { translation: es },
  fr: { translation: fr },
  hi: { translation: hi },
  ja: { translation: ja },
  ko: { translation: ko },
  ru: { translation: ru },
  tl: { translation: tl },
  vi: { translation: vi },
  zh: { translation: zh },
  bn: { translation: bn },
};

i18n.use(initReactI18next).init({
  lng: 'en',
  fallbackLng: 'en',
  resources: languages,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
